import { render } from "./Identify.vue?vue&type=template&id=d5f48e18&scoped=true&ts=true"
import script from "./Identify.vue?vue&type=script&lang=ts"
export * from "./Identify.vue?vue&type=script&lang=ts"

import "./Identify.vue?vue&type=style&index=0&id=d5f48e18&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5f48e18"]])

export default __exports__